import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './HelpCenter.css';
import { FaBell, FaBriefcase, FaCheckCircle, FaClipboardList, FaDownload, FaEnvelope, FaExclamationCircle, FaFileAlt, FaFileContract, FaInfoCircle, FaLightbulb, FaMagic, FaPaste, FaQuestionCircle, FaRocket, FaSave, FaSearch, FaTools, FaUserCircle } from 'react-icons/fa';

const HelpCenter = () => {
  const [activeCategory, setActiveCategory] = useState('getting-started');

  const handleCategoryChange = (category) => {
    setActiveCategory(category);
  };

  return (
    <div className="help-page">
      {/* SVG Definitions for Patterns */}
      <svg 
        width="0" 
        height="0" 
        style={{ position: 'absolute' }}
      >
        <defs>
          <pattern 
            id="gridPattern" 
            width="20" 
            height="20" 
            patternUnits="userSpaceOnUse"
          >
            <path 
              d="M 20 0 L 0 0 0 20" 
              fill="none" 
              stroke="white" 
              strokeWidth="0.5" 
              opacity="0.3"
            />
          </pattern>
        </defs>
      </svg>

      <div className="help-hero">
        <div className="help-hero__overlay">
          <svg 
            width="100%" 
            height="100%" 
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect 
              width="100%" 
              height="100%" 
              fill="url(#gridPattern)" 
            />
          </svg>
        </div>
        <div className="help-container">
          <h1 className="help-hero__title">Help Center</h1>
          <p className="help-hero__subtitle">Find answers to your questions and learn how to get the most out of CVance & OppLiy</p>
          
          <div className="help-search">
            <input 
              type="text" 
              placeholder="Search for help articles..." 
              className="help-search__input"
            />
            <button className="help-search__button">
              <FaSearch />
            </button>
          </div>
        </div>
      </div>

      <div className="help-container">
        <div className="help-content">
          <div className="help-sidebar">
            <h3 className="help-sidebar__title">Help Categories</h3>
            <ul className="help-sidebar__categories">
              <li 
                className={`help-sidebar__category ${activeCategory === 'getting-started' ? 'active' : ''}`}
                onClick={() => handleCategoryChange('getting-started')}
              >
                <FaRocket />
                <span>Getting Started</span>
              </li>
              <li 
                className={`help-sidebar__category ${activeCategory === 'cvance' ? 'active' : ''}`}
                onClick={() => handleCategoryChange('cvance')}
              >
                <FaFileAlt />
                <span>CVance - Resume Tailoring</span>
              </li>
              <li 
                className={`help-sidebar__category ${activeCategory === 'oppliy' ? 'active' : ''}`}
                onClick={() => handleCategoryChange('oppliy')}
              >
                <FaBriefcase />
                <span>OppLiy - Job Listings</span>
              </li>
              <li 
                className={`help-sidebar__category ${activeCategory === 'account' ? 'active' : ''}`}
                onClick={() => handleCategoryChange('account')}
              >
                <FaUserCircle />
                <span>Account Management</span>
              </li>
              <li 
                className={`help-sidebar__category ${activeCategory === 'troubleshooting' ? 'active' : ''}`}
                onClick={() => handleCategoryChange('troubleshooting')}
              >
                <FaTools />
                <span>Troubleshooting</span>
              </li>
            </ul>
            
            <div className="help-contact-box">
              <h4 className="help-contact-box__title">Still Need Help?</h4>
              <p className="help-contact-box__text">
                Can't find what you're looking for? Our support team is ready to assist you.
              </p>
              <Link to="/contact" className="help-contact-box__button">
                Contact Support
              </Link>
            </div>
          </div>
          
          <div className="help-main">
            {activeCategory === 'getting-started' && (
              <div className="help-category-content">
                <h2 className="help-category__title">Getting Started</h2>
                
                <div className="help-article">
                  <h3 className="help-article__title">Welcome to CVance & OppLiy</h3>
                  <p className="help-article__description">
                    A quick introduction to our platform and how it can help you with your job search process.
                  </p>
                  <div className="help-steps">
                    <div className="help-step">
                      <div className="help-step__number">1</div>
                      <div className="help-step__content">
                        <h4 className="help-step__title">Create Your Account</h4>
                        <p className="help-step__description">
                          Sign up for a free account to access all the features of CVance and OppLiy. You'll need to provide your email and create a password.
                        </p>
                      </div>
                    </div>
                    
                    <div className="help-step">
                      <div className="help-step__number">2</div>
                      <div className="help-step__content">
                        <h4 className="help-step__title">Complete Your Profile</h4>
                        <p className="help-step__description">
                          Add your education, work experience, skills, and other relevant information to your profile. This information will be used to tailor your resume.
                        </p>
                      </div>
                    </div>
                    
                    <div className="help-step">
                      <div className="help-step__number">3</div>
                      <div className="help-step__content">
                        <h4 className="help-step__title">Upload Your Resume</h4>
                        <p className="help-step__description">
                          Upload your existing resume to quickly populate your profile. We support PDF, DOCX, and other common file formats.
                        </p>
                      </div>
                    </div>
                    
                    <div className="help-step">
                      <div className="help-step__number">4</div>
                      <div className="help-step__content">
                        <h4 className="help-step__title">Find Job Opportunities</h4>
                        <p className="help-step__description">
                          Use OppLiy to discover job listings that match your skills and interests. Filter by location, job type, industry, and more.
                        </p>
                      </div>
                    </div>
                    
                    <div className="help-step">
                      <div className="help-step__number">5</div>
                      <div className="help-step__content">
                        <h4 className="help-step__title">Tailor Your Resume</h4>
                        <p className="help-step__description">
                          Once you find a job you want to apply for, use CVance to tailor your resume to match the job description. Your optimized resume will be available for download.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                
                <div className="help-article">
                  <h3 className="help-article__title">Understanding ATS and Why Resume Tailoring Matters</h3>
                  <p className="help-article__description">
                    Learn about Applicant Tracking Systems (ATS) and how tailoring your resume can increase your chances of getting an interview.
                  </p>
                  <div className="help-content-box">
                    <h4 className="help-content-box__title">What is an ATS?</h4>
                    <p className="help-content-box__text">
                      An Applicant Tracking System (ATS) is software used by employers to manage job applications. These systems scan resumes for relevant keywords to determine which candidates are the best match for a position.
                    </p>
                    <h4 className="help-content-box__title">Why Tailoring Matters</h4>
                    <p className="help-content-box__text">
                      When you submit a generic resume, it may not contain the specific keywords and phrases the ATS is looking for. By tailoring your resume to match the job description, you significantly increase your chances of getting past the ATS and reaching the hiring manager.
                    </p>
                    <h4 className="help-content-box__title">How CVance Helps</h4>
                    <p className="help-content-box__text">
                      CVance analyzes the job description and your resume to identify gaps and opportunities for improvement. It then creates an optimized version that highlights your most relevant skills and experiences, all without altering your core information.
                    </p>
                  </div>
                </div>
              </div>
            )}
            
            {activeCategory === 'cvance' && (
              <div className="help-category-content">
                <h2 className="help-category__title">CVance - Resume Tailoring</h2>
                
                <div className="help-article">
                  <h3 className="help-article__title">How to Tailor Your Resume with CVance</h3>
                  <p className="help-article__description">
                    A step-by-step guide to tailoring your resume for a specific job description using CVance.
                  </p>
                  <div className="help-image-steps">
                    <div className="help-image-step">
                      <div className="help-image-step__graphic">
                        <FaClipboardList />
                      </div>
                      <div className="help-image-step__content">
                        <h4 className="help-image-step__title">Step 1: Copy the Job Description</h4>
                        <p className="help-image-step__description">
                          Copy the full job description from the job listing, including requirements, responsibilities, and qualifications.
                        </p>
                      </div>
                    </div>
                    
                    <div className="help-image-step">
                      <div className="help-image-step__graphic">
                        <FaPaste />
                      </div>
                      <div className="help-image-step__content">
                        <h4 className="help-image-step__title">Step 2: Paste into CVance</h4>
                        <p className="help-image-step__description">
                          Paste the job description into the CVance tailoring tool and add any optional information like company name or job title.
                        </p>
                      </div>
                    </div>
                    
                    <div className="help-image-step">
                      <div className="help-image-step__graphic">
                        <FaCheckCircle />
                      </div>
                      <div className="help-image-step__content">
                        <h4 className="help-image-step__title">Step 3: Select Profile Elements</h4>
                        <p className="help-image-step__description">
                          Choose which elements from your profile to include in this tailored resume, such as specific education, skills, and experiences.
                        </p>
                      </div>
                    </div>
                    
                    <div className="help-image-step">
                      <div className="help-image-step__graphic">
                        <FaMagic />
                      </div>
                      <div className="help-image-step__content">
                        <h4 className="help-image-step__title">Step 4: Generate Tailored Resume</h4>
                        <p className="help-image-step__description">
                          Click "Generate" and our AI will optimize your resume for this specific job, highlighting relevant skills and experiences.
                        </p>
                      </div>
                    </div>
                    
                    <div className="help-image-step">
                      <div className="help-image-step__graphic">
                        <FaDownload />
                      </div>
                      <div className="help-image-step__content">
                        <h4 className="help-image-step__title">Step 5: Download and Apply</h4>
                        <p className="help-image-step__description">
                          Review the tailored resume, make any final adjustments, and download it in PDF format, ready to submit with your job application.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                
                <div className="help-article">
                  <h3 className="help-article__title">CVance Best Practices</h3>
                  <p className="help-article__description">
                    Tips and recommendations for getting the best results when using CVance to tailor your resume.
                  </p>
                  <div className="help-tips">
                    <div className="help-tip">
                      <div className="help-tip__icon">
                        <FaLightbulb />
                      </div>
                      <div className="help-tip__content">
                        <h4 className="help-tip__title">Use the Complete Job Description</h4>
                        <p className="help-tip__text">
                          Include the entire job posting, not just parts of it. This gives our algorithm the most information to work with.
                        </p>
                      </div>
                    </div>
                    
                    <div className="help-tip">
                      <div className="help-tip__icon">
                        <FaLightbulb />
                      </div>
                      <div className="help-tip__content">
                        <h4 className="help-tip__title">Maintain Accuracy</h4>
                        <p className="help-tip__text">
                          While CVance optimizes your resume presentation, never include skills or experiences you don't actually have.
                        </p>
                      </div>
                    </div>
                    
                    <div className="help-tip">
                      <div className="help-tip__icon">
                        <FaLightbulb />
                      </div>
                      <div className="help-tip__content">
                        <h4 className="help-tip__title">Tailor for Each Application</h4>
                        <p className="help-tip__text">
                          Create a fresh tailored resume for each job application rather than using the same version for multiple positions.
                        </p>
                      </div>
                    </div>
                    
                    <div className="help-tip">
                      <div className="help-tip__icon">
                        <FaLightbulb />
                      </div>
                      <div className="help-tip__content">
                        <h4 className="help-tip__title">Review Before Submitting</h4>
                        <p className="help-tip__text">
                          Always review your tailored resume before submitting it to ensure it accurately represents your qualifications.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
            
            {activeCategory === 'oppliy' && (
              <div className="help-category-content">
                <h2 className="help-category__title">OppLiy - Job Listings</h2>
                
                <div className="help-article">
                  <h3 className="help-article__title">Finding the Right Job Opportunities</h3>
                  <p className="help-article__description">
                    Learn how to use OppLiy's powerful search and filtering features to find relevant job opportunities.
                  </p>
                  <div className="help-content-box">
                    <h4 className="help-content-box__title">Search Functionality</h4>
                    <p className="help-content-box__text">
                      OppLiy aggregates job listings from across the United States. You can search for jobs using keywords, job titles, or company names. The more specific your search terms, the more relevant your results will be.
                    </p>
                    <h4 className="help-content-box__title">Filtering Options</h4>
                    <p className="help-content-box__text">
                      Refine your job search using filters for:
                    </p>
                    <ul className="help-content-box__list">
                      <li>Location (city, state, or remote)</li>
                      <li>Job type (full-time, part-time, contract)</li>
                      <li>Experience level (entry, mid, senior)</li>
                      <li>Industry or sector</li>
                      <li>Date posted (last 24 hours, week, month)</li>
                      <li>Salary range</li>
                    </ul>
                    <h4 className="help-content-box__title">Saving Searches</h4>
                    <p className="help-content-box__text">
                      Save your search criteria to quickly access relevant job listings in the future. You can also set up email alerts to be notified when new jobs matching your criteria are posted.
                    </p>
                  </div>
                </div>
                
                <div className="help-article">
                  <h3 className="help-article__title">Setting Up Job Alerts</h3>
                  <p className="help-article__description">
                    Get notified when new job opportunities that match your criteria are posted.
                  </p>
                  <div className="help-image-steps">
                    <div className="help-image-step">
                      <div className="help-image-step__graphic">
                        <FaSearch />
                      </div>
                      <div className="help-image-step__content">
                        <h4 className="help-image-step__title">Step 1: Perform a Search</h4>
                        <p className="help-image-step__description">
                          Search for jobs using keywords and filters that match your career interests.
                        </p>
                      </div>
                    </div>
                    
                    <div className="help-image-step">
                      <div className="help-image-step__graphic">
                        <FaSave />
                      </div>
                      <div className="help-image-step__content">
                        <h4 className="help-image-step__title">Step 2: Save Your Search</h4>
                        <p className="help-image-step__description">
                          Click "Save Search" and give your search a name (e.g., "Software Developer Jobs in Boston").
                        </p>
                      </div>
                    </div>
                    
                    <div className="help-image-step">
                      <div className="help-image-step__graphic">
                        <FaBell />
                      </div>
                      <div className="help-image-step__content">
                        <h4 className="help-image-step__title">Step 3: Set Alert Frequency</h4>
                        <p className="help-image-step__description">
                          Choose how often you want to receive alerts: daily, weekly, or as soon as new jobs are posted.
                        </p>
                      </div>
                    </div>
                    
                    <div className="help-image-step">
                      <div className="help-image-step__graphic">
                        <FaEnvelope />
                      </div>
                      <div className="help-image-step__content">
                        <h4 className="help-image-step__title">Step 4: Receive Notifications</h4>
                        <p className="help-image-step__description">
                          You'll receive email notifications about new job opportunities that match your saved search criteria.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
            
            {activeCategory === 'account' && (
              <div className="help-category-content">
                <h2 className="help-category__title">Account Management</h2>
                
                <div className="help-article">
                  <h3 className="help-article__title">Managing Your Profile</h3>
                  <p className="help-article__description">
                    Learn how to update and maintain your profile information for optimal results.
                  </p>
                  <div className="help-content-box">
                    <h4 className="help-content-box__title">Profile Sections</h4>
                    <p className="help-content-box__text">
                      Your profile consists of several sections that should be kept up-to-date:
                    </p>
                    <ul className="help-content-box__list">
                      <li><strong>Personal Information:</strong> Name, contact details, location</li>
                      <li><strong>Education:</strong> Degrees, institutions, dates, GPA, coursework</li>
                      <li><strong>Experience:</strong> Work history, roles, responsibilities, achievements</li>
                      <li><strong>Skills:</strong> Technical, soft, and industry-specific skills</li>
                      <li><strong>Projects:</strong> Personal or professional projects, technologies used</li>
                      <li><strong>Certifications:</strong> Professional certifications and credentials</li>
                    </ul>
                    <h4 className="help-content-box__title">Updating Your Profile</h4>
                    <p className="help-content-box__text">
                      To update your profile, navigate to the Profile page from the dashboard and click the Edit button for the section you want to update. Make your changes and click Save to confirm.
                    </p>
                    <h4 className="help-content-box__title">Profile Completion Score</h4>
                    <p className="help-content-box__text">
                      Your profile completion score indicates how complete your profile is. A more complete profile leads to better tailoring results. Aim for a score of at least 80% for optimal performance.
                    </p>
                  </div>
                </div>
                
                <div className="help-faq">
                  <h3 className="help-faq__title">Account FAQs</h3>
                  
                  <div className="help-faq__item">
                    <div className="help-faq__question">
                      How do I change my password?
                    </div>
                    <div className="help-faq__answer">
                      To change your password, go to Account Settings, scroll to the Security section, and click "Change Password." You'll need to enter your current password and your new password twice to confirm.
                    </div>
                  </div>
                  
                  <div className="help-faq__item">
                    <div className="help-faq__question">
                      Can I update my email address?
                    </div>
                    <div className="help-faq__answer">
                      Yes, you can update your email address in the Account Settings page. After changing your email, you'll need to verify the new address by clicking a link sent to that email.
                    </div>
                  </div>
                  
                  <div className="help-faq__item">
                    <div className="help-faq__question">
                      How can I delete my account?
                    </div>
                    <div className="help-faq__answer">
                      To delete your account, go to Account Settings, scroll to the bottom, and click "Delete Account." You'll be asked to confirm this action. Please note that account deletion is permanent and cannot be undone.
                    </div>
                  </div>
                  
                  <div className="help-faq__item">
                    <div className="help-faq__question">
                      What happens to my data when I delete my account?
                    </div>
                    <div className="help-faq__answer">
                      When you delete your account, all your personal information, profile data, and tailored resumes are permanently removed from our system within 30 days, in accordance with our Privacy Policy.
                    </div>
                  </div>
                </div>
              </div>
            )}
            
            {activeCategory === 'troubleshooting' && (
              <div className="help-category-content">
                <h2 className="help-category__title">Troubleshooting</h2>
                
                <div className="help-article">
                  <h3 className="help-article__title">Common Issues and Solutions</h3>
                  <p className="help-article__description">
                    Solutions to frequently encountered problems when using CVance and OppLiy.
                  </p>
                  
                  <div className="help-troubleshooting">
                    <div className="help-troubleshooting__item">
                      <div className="help-troubleshooting__problem">
                        <FaExclamationCircle />
                        <h4>Problem: Unable to upload resume</h4>
                      </div>
                      <div className="help-troubleshooting__solution">
                        <h5>Solution:</h5>
                        <ul>
                          <li>Check that your file is in a supported format (PDF, DOCX, DOC, TXT)</li>
                          <li>Ensure the file size is under 5MB</li>
                          <li>Try converting your file to PDF and uploading again</li>
                          <li>Clear your browser cache and try again</li>
                        </ul>
                      </div>
                    </div>
                    
                    <div className="help-troubleshooting__item">
                      <div className="help-troubleshooting__problem">
                      <FaExclamationCircle />
                        <h4>Problem: Tailored resume missing information</h4>
                      </div>
                      <div className="help-troubleshooting__solution">
                        <h5>Solution:</h5>
                        <ul>
                          <li>Ensure your profile is complete with all relevant information</li>
                          <li>Check that you've selected all appropriate profile elements during tailoring</li>
                          <li>Try providing a more detailed job description</li>
                          <li>If specific sections are missing, manually add them after tailoring</li>
                        </ul>
                      </div>
                    </div>
                    
                    <div className="help-troubleshooting__item">
                      <div className="help-troubleshooting__problem">
                      <FaExclamationCircle />
                        <h4>Problem: No job listings appearing in search results</h4>
                      </div>
                      <div className="help-troubleshooting__solution">
                        <h5>Solution:</h5>
                        <ul>
                          <li>Try using broader or more general search terms</li>
                          <li>Remove some filters that might be too restrictive</li>
                          <li>Check your location settings and consider expanding the search radius</li>
                          <li>Try searching by industry or job category instead of specific job titles</li>
                        </ul>
                      </div>
                    </div>
                    
                    <div className="help-troubleshooting__item">
                      <div className="help-troubleshooting__problem">
                      <FaExclamationCircle />
                        <h4>Problem: Can't login to account</h4>
                      </div>
                      <div className="help-troubleshooting__solution">
                        <h5>Solution:</h5>
                        <ul>
                          <li>Verify you're using the correct email address</li>
                          <li>Use the "Forgot Password" link to reset your password</li>
                          <li>Check if you're using social login (Google, LinkedIn) and try that method</li>
                          <li>Clear browser cookies and cache, then try again</li>
                          <li>Ensure your account hasn't been deactivated for inactivity</li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
                
                <div className="help-article">
                  <h3 className="help-article__title">Technical Requirements</h3>
                  <p className="help-article__description">
                    Learn about the technical requirements for using CVance and OppLiy optimally.
                  </p>
                  <div className="help-content-box">
                    <h4 className="help-content-box__title">Supported Browsers</h4>
                    <p className="help-content-box__text">
                      CVance and OppLiy work best on the following browsers:
                    </p>
                    <ul className="help-content-box__list">
                      <li>Google Chrome (latest version)</li>
                      <li>Mozilla Firefox (latest version)</li>
                      <li>Safari (latest version)</li>
                      <li>Microsoft Edge (latest version)</li>
                    </ul>
                    <h4 className="help-content-box__title">Mobile Compatibility</h4>
                    <p className="help-content-box__text">
                      Our platforms are responsive and work on mobile devices, but for the best experience, especially when tailoring resumes, we recommend using a desktop or laptop computer.
                    </p>
                    <h4 className="help-content-box__title">File Requirements</h4>
                    <p className="help-content-box__text">
                      For resume uploads, we support the following file formats:
                    </p>
                    <ul className="help-content-box__list">
                      <li>PDF (.pdf)</li>
                      <li>Microsoft Word (.docx, .doc)</li>
                      <li>Plain Text (.txt)</li>
                      <li>Rich Text Format (.rtf)</li>
                    </ul>
                    <p className="help-content-box__text">
                      Maximum file size: 5MB
                    </p>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
        
        <section className="help-quick-links">
          <h2 className="help-quick-links__title">Quick Links</h2>
          <div className="help-quick-links__grid">
            <Link to="/faq" className="help-quick-link">
              <div className="help-quick-link__icon">
                <FaQuestionCircle />
              </div>
              <div className="help-quick-link__text">
                <h3>Frequently Asked Questions</h3>
                <p>Find answers to common questions about our services</p>
              </div>
            </Link>
            
            <Link to="/contact" className="help-quick-link">
              <div className="help-quick-link__icon">
                <FaEnvelope />
              </div>
              <div className="help-quick-link__text">
                <h3>Contact Support</h3>
                <p>Get in touch with our support team for personalized help</p>
              </div>
            </Link>
            
            <Link to="/terms" className="help-quick-link">
              <div className="help-quick-link__icon">
                <FaFileContract />
              </div>
              <div className="help-quick-link__text">
                <h3>Terms of Service</h3>
                <p>Read our terms of service and privacy policy</p>
              </div>
            </Link>
            
            <Link to="/about" className="help-quick-link">
              <div className="help-quick-link__icon">
                <FaInfoCircle />
              </div>
              <div className="help-quick-link__text">
                <h3>About Us</h3>
                <p>Learn more about CVance and OppLiy</p>
              </div>
            </Link>
          </div>
        </section>
        
        <section className="help-disclaimer">
          <div className="disclaimer-content">
            <h3 className="disclaimer-title">Project Status Disclaimer</h3>
            <p className="disclaimer-text">
              CVance and OppLiy are currently in the project development phase. We are not a registered 
              company or LLC at this time. This is a non-profit project aimed at addressing challenges 
              in the job search process. The platforms and services described are under development and 
              subject to change. Any information provided is for informational purposes only and does not 
              constitute a commercial offering or binding agreement.
            </p>
          </div>
        </section>
      </div>
    </div>
  );
};

export default HelpCenter;